<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll" style="padding-top: 50px;">
            <!-- banner -->
            <div class="newsPage-banner scroll-container">
                <img src="https://resource.rcclchina.com.cn/News/newsBanner.jpg">
                <div class="bg-cover abs"></div>
                <div class="abs newsPage-title">
                    <div class="newPage-title-title1">皇家新闻中心</div>
                    <div class="newPage-title-title2">汇集最新皇家加勒比游轮资讯，了解掌握皇家游轮相关动态让您的旅途更加精彩！</div>
                </div>
            </div>
            <!-- nav -->
            <NewsNav :activeIndex="NewsType" @on-change="changeType" :newsCount="newsCount"></NewsNav>
            <!-- list -->
            <div class="newsPage-news-content scroll-container">
                <div class="newsPage-news-cate">
                    <div class="newsPage-news-item" v-for="item in newsList" :key="item.id">
                        <div class="newsPage-news-image div--inlineBlock">
                            <img :src="item.image" :alt="item.title">
                        </div>
                        <div class="newsPage-news-text div--inlineBlock">
                            <div class="newsPage-news-title">{{item.title}}</div>
                            <div class="newsPage-news-detail">
                                <div class="newsPage-news-createtime div--inlineBlock">{{item.createTime}}</div>
                                <div class="newsPage-news-detailBtn div--inlineBlock">阅读详情</div>
                            </div>
                        </div>
                        <router-link class="hold-link external" :to="`/Rccl.CustomPage/RcclNews/Detail/${item.id}.html`"></router-link>
                    </div>
                </div>
                <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading" :identifier="thisIdentifier">
                    <span slot="spinner"></span>
                    <span slot="no-more"></span>
                    <div class="news-list-nodata" slot="no-results">
                        <p>暂无数据</p>
                    </div>
                </infinite-loading>
            </div>

        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import NewsNav from '@/components/CustomPage/NewsNav.vue'
    import InfiniteLoading from 'vue-infinite-loading'
    export default {
        name: 'RcclNewsIndex',
        components: {
            NewsNav,
            InfiniteLoading
        },
        data () {
            return {
                userToken: '',
                newsList: [],
                pageNum: 0,
                pageSize: 10,
                NewsType: 1,
                newsCount: 0,
                thisIdentifier: +Date.now()
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '新闻中心')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
                const type = this.$route.query.newsType
                if (type) this.NewsType = parseInt(type)
                const { data } = await api.page.getNewsCount()
                if (data && data > 0) {
                    this.newsCount = data
                }
            },
            async infiniteHandler ($state) {
                this.$loading.show()
                const data = await this.getNews({
                    offset: this.pageNum * this.pageSize,
                    limit: this.pageSize,
                    NewsType: this.NewsType
                })
                const newList = data.rcclNews
                if (newList.length > 0) {
                    this.newsList = [...this.newsList, ...newList]
                    this.pageNum++
                    $state.loaded()
                } else {
                    $state.complete()
                }
                this.$loading.hide()
            },
            async getNews ({ offset, limit, NewsType }) {
                const {success, data, errMsg} = await api.page.getNews({ offset, limit, NewsType })
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            changeType (type) {
                this.NewsType = type
                this.newsList = []
                this.pageNum = 0
                this.thisIdentifier = +Date.now()
            }
        }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    /**** news ****/
    .newsPage-banner {
        position: relative;
        line-height: 0;
    }

    .newsPage-banner .bg-cover {
        top: 0;
        left: 0;
    }

    .newsPage-banner img {
        width: 100%;
    }

    .newsPage-title {
        font-size: 12px;
        color: white;
        top: 0;
        left: 0;
    }

    .newsPage-title .newPage-title-title1 {
        position: relative;
        text-align: center;
        margin-top: 53px;
        font-weight: bold;
        font-size: 13px;
    }

    .newsPage-title .newPage-title-title2 {
        text-align: center;
        margin: 16px auto;
        width: 326px;
        position: relative;
        white-space: normal;
        line-height: 1.5;
    }

    .newsPage-news-content {
        background: white;
        padding: 5px 10px 80px 10px;
        height: calc(100vh - 50px - 148px - 42px);
        overflow: scroll;
    }

    .newsPage-news-item {
        height: 146px;
        background-color: #f6f6f6;
        padding: 5px;
        margin-bottom: 5px;
        position:relative;
    }

    .newsPage-news-item .newsPage-news-image {
        width: 140px;
        height: 140px;
        overflow: hidden;
    }

    .newsPage-news-item .newsPage-news-image img {
        width: 150%;
        position: relative;
        left: -25%;
    }

    .newsPage-news-item .newsPage-news-text {
        position: relative;
        width: 195px;
        height: 140px;
        font-size: 14px;
        color: black;
        margin-left: 8px;
    }

    .newsPage-news-item .newsPage-news-title {
        margin-top: 5px;
        font-weight: 500;
    }

    .newsPage-news-item .newsPage-news-detail {
        position: absolute;
        bottom: 8px;
    }

    .newsPage-news-item .newsPage-news-createtime {
        color: #777;
    }

    .newsPage-news-item .newsPage-news-detailBtn {
        margin-left: 27px;
        padding: 3px 15px;
        font-size: 13px;
        font-weight: 300;
        color: white;
        background-color: #f9b811;
    }
    .newsPage-news-item .hold-link {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
    }
</style>
